export enum InvestmentType {
  ECF = 1,
  Note = 2,
  Token = 3,
}
